import {
  getTimestampDataHoraPedido,
  RetornoAcaoLimparColuna,
  RetornoAtualizacaoStatusPedido,
  RetornoNovosPedidos,
  RetornoPedidosDoDia,
  StatusPedido,
  TStatusPedido,
} from "./../models/pedido";
import { Board } from "src/app/models/board.model";
import { DialogService } from "./dialog.service";
import { SnackbarService } from "./snackbar.service";
import { AppService } from "./app.service";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { Pedido } from "../models/pedido";
import { OpcaoEntrega, QuantidadePedidos } from "../models/order";
import { Subject } from "rxjs";
import { transferArrayItem } from "@angular/cdk/drag-drop";
import { KanbanPedido } from "../kanbam/KanbamPedido";
import { EventService } from "./event.service";
import { NotificacaoService } from "./notificacao.service";

@Injectable({
  providedIn: "root",
})
export class PedidoService {
  orders: Pedido[];
  ultimoPedido: number;
  pedidosSubject = new Subject();
  novosPedidosSubject = new Subject();
  quantidadePedidos: QuantidadePedidos;
  kanban: Board;
  kanbanMontado = false;
  mapaKanban = {};
  filtroExibicao = "Todos";
  filtroBusca = "";

  constructor(
    private apiService: ApiService,
    private appService: AppService,
    private snackbarService: SnackbarService,
    private dialogService: DialogService,
    private eventService: EventService,
    private notificacaoService: NotificacaoService
  ) {
  }

  async salvarStatusPedido(Hash: string, Status: string): Promise<RetornoAtualizacaoStatusPedido> {

    return new Promise((resolve, reject) => {
      this.apiService.salvarStatusPedido(Hash, Status).subscribe((resposta) => {
        if (resposta.status === "success") {
          resolve(resposta.data);
          return;
        }
        reject(resposta.data);
      });
    })
  }

  async limparPedidosDoGrupo(arrayHash: string[]): Promise<RetornoAcaoLimparColuna> {
    return new Promise((resolve, reject) => {
      this.apiService.limparPedidosDoGrupo(arrayHash).subscribe((resposta) => {
        if (resposta.status === "success") {
          resolve(resposta.data)
        } else {
          this.snackbarService.Error(String(resposta.data));
          reject(resposta.data);
        }
      });
    });
  }

  gerarStringAtualizacao() {
    if (!this.kanban?.columns?.length) {
      return "";
    }

    const itens = [];
    for (const coluna of this.kanban.columns) {
      for (const pedido of coluna.tasks) {
        itens.push(`${pedido.id}:${pedido.Atualizacao}`);
      }
    }
    return itens.length ? itens.join(",") : "";
  }

  atualizarTempoDoPedidoKanban() {
    for (const coluna of this.kanban.columns) {
      for (const pedido of coluna.tasks) {
        const horaPedido = new Date(pedido.DataHora);
        const horaEntrega = this.addicionarMinutos(
          horaPedido,
          Number(pedido.TempoEntrega)
        );
        pedido.TempoRestante = this.calcularTempoRestante(horaEntrega);
        pedido.Progresso = this.calcularProgressoPedido(pedido);
      }
    }
  }

  getPedidosDoDia(): Promise<RetornoPedidosDoDia> {
    return new Promise((resolve, reject) => {
      this.apiService.getPedidosDoDia().subscribe((resposta) => {
        if (resposta.status === "success") {
          resolve(resposta.data)
        } else {
          this.snackbarService.Error(String(resposta.data));
        }
      });
    })
  }

  limparMonitor(idUltimoPedido: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiService.limparMonitor(idUltimoPedido).subscribe((dados) => {
        if (dados.status === "success") {
          this.snackbarService.Success(dados.data);
          resolve(true);
        } else {
          this.snackbarService.Error(dados.data);
          reject(false);
        }
      });
    })
  }

  getTimestampDataAgendamentoPedido(order: Pedido) {
    if (!order?.Pedido?.DadosAgendamento?.Data) {
      return 0;
    }

    const dados = order?.Pedido?.DadosAgendamento ?? {};
    const data = dados?.Data + " " + dados?.Hora + ":00";
    const parts = data.match(/\d+/g);

    if (parts?.length < 6) {
      return 0;
    }

    const [ano, mes, dia, hora, minutos, segundos] = parts;
    return new Date(
      `${mes}/${dia}/${ano} ${hora}:${minutos}:${segundos}`
    ).getTime();
  }

  limparDadosDoMonitor() {
    for (const column of this.kanban?.columns) {
      column.tasks = [];
    }
    this.orders = [];
  }

  imprimirPedido(element: any) {
    const iframe = document.getElementById(
      "iframe-pedido"
    ) as HTMLIFrameElement;

    console.log(iframe);
    iframe.onload = () => {
      setTimeout(() => {
        element.close();
      }, 2000);
    };
  }

  addicionarMinutos(date: any, minutes: number) {
    return new Date(date.getTime() + minutes * 60000);
  }

  calcularProgressoPedido(pedido: Pedido) {
    const statusPedido = new TStatusPedido(pedido.status);
    let tempoRestante = pedido.TempoRestante;
    const tempoEntrega = Number(pedido.TempoEntrega);
    const ehPedidoAgendado = statusPedido.is(StatusPedido.AGENDADO);
    const timestampAgendamento = pedido?.TimestampAgendamento ?? 0;

    if (!tempoEntrega && !ehPedidoAgendado) {
      return null;
    }

    if (statusPedido.in([StatusPedido.FINALIZADO, StatusPedido.CANCELADO])) {
      return 0;
    }

    if (!ehPedidoAgendado || !timestampAgendamento) {
      return tempoRestante < 0
        ? 100
        : 100 - Math.round((tempoRestante * 100) / tempoEntrega);
    }

    const timestampCriacao = getTimestampDataHoraPedido(pedido);
    const timestampNow = new Date().getTime();
    const tempoTotal = timestampAgendamento - timestampCriacao;
    tempoRestante = timestampAgendamento - timestampNow;

    return timestampNow >= timestampAgendamento || !tempoTotal
      ? 100
      : 100 - Math.round((tempoRestante * 100) / tempoTotal);
  }

  calcularTempoRestante(horaPrevista: any) {
    const previsao = horaPrevista?.getTime() ?? 0;
    const horaAgora = new Date().getTime() ?? 0;
    const diff = Number(previsao) - Number(horaAgora);
    return diff !== 0 ? Math.floor(diff / 60000) : 0;
  }

  mapearKanban() {
    this.mapaKanban = {};
    this.kanban?.columns.forEach((coluna: any, idxColuna: number) => {
      coluna.tasks.forEach((pedido: Pedido, idxPedido: number) => {
        this.mapaKanban[`P${pedido.id}`] = [idxColuna, idxPedido];
      });
    });
  }

  avancarColuna(statusAtual: StatusPedido) {
    const status = new TStatusPedido(statusAtual);
    const nextStatus = status.next().toString();
    const colunaAtual = this.kanban?.getColumnByStatus(status.toString());
    const proximaColuna = this.kanban?.getColumnByStatus(nextStatus);
    const arrayHash = colunaAtual.getHashPedidos();

    this.apiService
      .salvarStatusPedido(null, nextStatus, arrayHash)
      .subscribe((dados) => {
        if (dados.status === "success") {
          colunaAtual.moveto(proximaColuna, nextStatus);
        }
      });
  }

  voltarColuna(statusAtual: string) {
    const status = new TStatusPedido(statusAtual);
    const prevStatus = status.prev().toString();
    const colunaAtual = this.kanban?.getColumnByStatus(status.toString());
    const colunaAnterior = this.kanban?.getColumnByStatus(prevStatus);
    const arrayHash = colunaAtual.getHashPedidos();

    this.apiService
      .salvarStatusPedido(null, prevStatus, arrayHash)
      .subscribe((dados) => {
        if (dados.status === "success") {
          colunaAtual.moveto(colunaAnterior, prevStatus);
        }
      });
  }

  limparColuna(statusAtual: string) {
    this.dialogService
      .confirm(
        "Confirmação",
        "Todos os pedidos desta coluna serão limpos.<br><br><b>Deseja confirmar?</b>"
      )
      .then(() => {
        const status = new TStatusPedido(statusAtual);
        const column = this.kanban?.getColumnByStatus(status.toString());
        const pedidos = column?.tasks;

        const arrayHash =
          pedidos?.map((pedido: Pedido) => {
            return pedido.Hash;
          }) ?? [];

        this.apiService.ocultarPedidos(arrayHash).subscribe((dados) => {
          if (dados.status === "success") {
            this.snackbarService.Success(dados.data);
            column.clearTasks();
          } else {
            this.snackbarService.Error(dados.data);
          }
        });
      })
      .catch((error) => { });
  }

  autoconfirmarPedidos(status, targetStatus, hashPedidos = []) {
    const coluna = this.kanban?.getColumnByStatus(status);
    const target = this.kanban?.getColumnByStatus(targetStatus);

    this.apiService
      .salvarStatusPedido(null, targetStatus, hashPedidos)
      .subscribe((dados) => {
        if (dados.status === "success") {
          coluna.moveto(target, targetStatus);
          this.snackbarService.Success(
            `${hashPedidos.length} pedido(s) movido(s) automaticamente!`
          );
        }
      });
  }

  atualizarPedidosAlterados(pedidos: Pedido[]) {
    for (const dadosPedidoAtualizado of pedidos) {
      let pedido = this.procurarPedidoNoKanban(
        Number(dadosPedidoAtualizado.id)
      );

      if (!pedido) {
        this.mapearKanban();
        pedido = this.procurarPedidoNoKanban(Number(dadosPedidoAtualizado.id));
      }

      if (pedido) {
        const dadosAtualizados = {
          ...pedido.dados,
          ...dadosPedidoAtualizado,
        };
        this.kanban.columns[pedido.indiceColuna].tasks[pedido.ordemArray] =
          dadosAtualizados;

        if (
          Number(pedido.dados.status) !== Number(dadosPedidoAtualizado.status)
        ) {
          this.respocisionarPedidoNoKanban(
            pedido.indiceColuna,
            dadosPedidoAtualizado.status,
            pedido.ordemArray
          );
          this.mapearKanban();
        }
      }
    }
    this.mapearKanban();
  }

  respocisionarPedidoNoKanban(
    statusAtual: number | string,
    novoStatus: number | string,
    indiceAtual: number
  ) {
    novoStatus = Number(novoStatus) - 1;
    const colunaAtual = this.kanban.columns[statusAtual].tasks;
    const novaColuna = this.kanban.columns[novoStatus].tasks;

    transferArrayItem(
      colunaAtual,
      novaColuna,
      indiceAtual,
      novaColuna?.length ?? 0
    );
  }

  procurarPedidoNoKanban(id: number) {
    const posicaoKanban = this.mapaKanban[`P${id}`] ?? null;
    if (posicaoKanban && posicaoKanban?.length === 2) {
      const indiceColuna = posicaoKanban[0];
      const ordemArray = posicaoKanban[1];
      const pedido = this.kanban.columns[indiceColuna].tasks[ordemArray];
      if (Number(pedido?.id) === id) {
        return {
          dados: pedido,
          indiceColuna,
          ordemArray,
        };
      }
    }
    return null;
  }

  atualizarItemNoKanbam(pedido: Pedido, dados: Pedido) { }

  getPedidos() {
    const tempoPermanencia = this.notificacaoService.tempoPermanenciaNoMonitorEmHoras;
    this.apiService.getPedidos(tempoPermanencia).subscribe((dados) => {
      if (dados.status === "success") {
        this.eventService.onGetListaPedidos.next(dados.data.Pedidos);
        this.ultimoPedido = dados.data.UltimoPedido ?? null;
        this.quantidadePedidos = dados.data.Quantidade;
        this.appService.statusAbertura = dados.data.StatusAbertura ?? null;
        this.appService.tempoEntrega = dados.data.TempoEntrega ?? 0;
        this.appService.inputTempoEntrega = dados.data.TempoEntrega ?? 0;
      }
    });
  }

  getNovosPedidos(ultimoPedido: number, atualizacao: string, tempoLimite: number): Promise<RetornoNovosPedidos> {
    return new Promise((resolve, reject) => {
      this.apiService
        .getNovosPedidos(ultimoPedido, atualizacao, tempoLimite)
        .subscribe((resposta) => {
          if (resposta.status === "success") {
            resolve(resposta.data);
          } else {
            reject(String(resposta.data));
          }
        });
    })
  }

  atualizarContadorPedidos(pedidos: Pedido[]) {
    for (const pedido of pedidos) {
      if (pedido.Pedido.OpcaoEntrega === OpcaoEntrega.ENTREGA) {
        this.quantidadePedidos.Pedidos =
          Number(this.quantidadePedidos.Pedidos) + 1;
        this.quantidadePedidos.Entrega =
          Number(this.quantidadePedidos.Entrega) + 1;
        this.quantidadePedidos.Consumo =
          Number(this.quantidadePedidos.Consumo) + 1;
        this.quantidadePedidos.Retirada =
          Number(this.quantidadePedidos.Retirada) + 1;
      }
    }
  }
}
